<template>
  <div class="shoushi_project1_wrap">
    <headerBlack-view></headerBlack-view>
    <div class="introduce_wrap">
      <div class="introduce flex-layout">
        <div class="introduce_left">
          <div class="introduce_title flex-layout">
            <img src="@/assets/yunqiao/menu.png" />
            <div class="flex-column">
              <span>项目介绍</span>
              <img src="@/assets/yunqiao/introduce.png" />
            </div>
          </div>
          <div class="introduce_name">名师联盟 双师课堂</div>
          <div class="introduce_detail">
            遴选项目校，结合实证数据对学生语、数、英、思政学科的基础情况、学习进阶
            、能力提升进行有针对性的研究与分析。为每位学员提供每学期的学习行为分析及
            反馈报告，每学期末为学员的每个学科分别出具一份详细的数据报告。
          </div>
        </div>
        <div class="introduce_right flex-layout">
          <div class="introduce_item flex-column-center">
            <img src="@/assets/yunqiao/classroom.png" />
            <span>课堂共享</span>
            <span>Classroom Sharing</span>
          </div>
          <div class="introduce_item flex-column-center">
            <img src="@/assets/yunqiao/resource.png" />
            <span>资源交流</span>
            <span>Resource Exchange</span>
          </div>
          <div class="introduce_item flex-column-center">
            <img src="@/assets/yunqiao/win.png" />
            <span>合作共赢</span>
            <span>Win-Win</span>
          </div>
        </div>
      </div>
    </div>
    <div class="feature_wrap">
      <div class="feature_top flex-layout">
        <img src="@/assets/yunqiao/menu.png" />
        <div class="flex-column">
          <span>产品特点</span>
          <img src="@/assets/yunqiao/feature.png" />
        </div>
      </div>
      <div class="feature_bottom flex-layout">
        <div class="feature_item flex-column">
          <div class="flex-align-around">
            <img src="@/assets/yunqiao/feature1.png" />
          </div>
          <span>精准落地互动</span>
          <span>合作双负责人确保合作精准落地</span>
        </div>
        <div class="feature_item flex-column">
          <div class="flex-align-around">
            <img src="@/assets/yunqiao/feature2.png" />
          </div>
          <span>专家教师互相交流</span>
          <span>实现优势互补，不断优化处理学习者问题的最佳方案</span>
        </div>
        <div class="feature_item flex-column">
          <div class="flex-align-around">
            <img src="@/assets/yunqiao/feature3.png" />
          </div>
          <span>学习情境互动</span>
          <span>创设学习情境、设置学习任务与计划，实现优势互补</span>
        </div>
        <div class="feature_item flex-column">
          <div class="flex-align-around">
            <img src="@/assets/yunqiao/feature4.png" />
          </div>
          <span>同屏互动</span>
          <span>实现异地面对面交流、学习、互动</span>
        </div>
      </div>
    </div>
    <div class="architecture_wrap">
      <div class="architecture">
        <div class="architecture_top flex-layout">
          <img src="@/assets/yunqiao/menu.png" />
          <div class="flex-column">
            <span>架构形式</span>
            <img src="@/assets/yunqiao/architecture.png" />
          </div>
        </div>
        <div class="architecture_bottom flex-layout">
          <div class="architecture_left flex-column">
            <div class="flex-column">
              <p>核心</p>
              <p>指导者提升为核心，屏共享课堂，创设学习情境、设置学习任务与计划、使北京和银川优质教育资源互通共享。</p>
            </div>
            <div class="flex-column">
              <p>数据支持</p>
              <p>依托大数据支持，做到指导者和学习者有据可依不断优化处理学习者问题的最佳方案，实现优势互补。</p>
            </div>
          </div>
          <div class="architecture_middle">
            <div class="midddle_top flex-align">
              <div class="circle flex-align-around">
                <img src="@/assets/yunqiao/hexin.png" />
              </div>
              <div class="circle flex-align-around">
                <img src="@/assets/yunqiao/ketang.png" />
              </div>
            </div>
            <div class="middle_mid flex-align-center">
                <img src="@/assets/yunqiao/loop.png" />
                <div></div>
            </div>
            <div class="midddle_bottom flex-align">
              <div class="circle flex-align-around">
                <img src="@/assets/yunqiao/shuju.png" />
              </div>
              <div class="circle flex-align-around">
                <img src="@/assets/yunqiao/ceping.png" />
              </div>
            </div>
          </div>
          <div class="architecture_right">
            <div class="flex-column">
              <p>北京课堂、银川课堂</p>
              <p>京银两地同屏共享课堂，创设学习情境、设置学习任务与计划，使学习者与指导者实现实时双向互动。</p>
            </div>
            <div class="flex-column">
              <p>课堂、辅导、测评、活动</p>
              <p>
                京银两地师生参加四同活动：同上课、同辅导、同测评，同活动，使学习者获得优质课程资源和精准化学习资源，
                以及经过评测后定制化的学习辅导和特色社团服务，使指导者增加相互交流和提升的机会，实现优势互补。
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="win_wrap">
         <div class="win_top flex-layout">
          <img src="@/assets/yunqiao/menu.png" />
          <div class="flex-column">
            <span>合作共赢</span>
            <img src="@/assets/yunqiao/win2.png" />
          </div>
        </div>
        <div class="win_bottom flex-layout">
            <div class="win_item flex-column-center">
                <img src="@/assets/yunqiao/win_item1.png"/>
                <span>共享式交流</span>
                <span>Shared Communication</span>
            </div>
             <div class="win_item flex-column-center">
                <img src="@/assets/yunqiao/win_item2.png"/>
                <span>普惠37所学校</span>
                <span>37 Pratt & Whitney Schools</span>
            </div>
             <div class="win_item flex-column-center">
                <img src="@/assets/yunqiao/win_item3.png"/>
                <span>丰富互动活动项目</span>
                <span>Rich Interactive Activities</span>
            </div>
             <div class="win_item flex-column-center">
                <img src="@/assets/yunqiao/win_item4.png"/>
                <span>优秀教师双向提升</span>
                <span>Two-way Promotion</span>
            </div>
             <div class="win_item flex-column-center">
                <img src="@/assets/yunqiao/win_item5.png"/>
                <span>学习者资源共享</span>
                <span>Learner Resource Sharing</span>
            </div>
        </div>
    </div>
    <footer-view></footer-view>
  </div>
</template>

<script>
export default {};
</script>

<style lang="less">
@import "./less/shoushi_project1.less";
</style>